import { AssignDeviceActions } from './assign-device-actions';
import { AuthActions } from './auth-actions';
import { ChronometerTickActions } from './chronometer-actions';
import { HomeAction } from './home-actions';
import { OrganisationActions } from './organisation-actions';
import { PatientActions } from './patientActions/patient-actions';
import { PhoneVerificationActions } from './phoneVerification-actions';
import { UploadDevicesActions } from './preregisteredDevicesUpload-actions';
import { ReportActions } from './report-actions';
import { SettingsActions } from './settings-actions';
import { UsersActions } from './users-actions';

export const CLEAR_STORE = 'CLEAR_STORE';

export const clearStore = () => ({
  type: CLEAR_STORE,
});

export type AllActions =
  | AuthActions
  | ChronometerTickActions
  | PatientActions
  | UploadDevicesActions
  | HomeAction
  | OrganisationActions
  | SettingsActions
  | UsersActions
  | PhoneVerificationActions
  | ReportActions
  | AssignDeviceActions;
